import React, { PureComponent } from 'react';
import cn from 'classnames';
import { FormGroup, Label, Col } from 'reactstrap';
import Select from 'react-select';
import { FormattedMessage } from 'react-intl';
import { array, string, func } from 'prop-types';

class TimezoneSelector extends PureComponent {
  static propTypes = {
    timezones: array.isRequired,
    selected: string.isRequired,
    onChangeTimezone: func.isRequired,
    error: string,
  };

  static defaultProps = {
    timezones: [],
  };

  handleChange = (data) => {
    if (data && data.value) {
      this.props.onChangeTimezone(data.value);
    }
  };

  getClassNames = () => {
    const { theme, error } = this.props;
    // if (theme === 4) {
    //   if (error) {
    //     return 'has-error mx-0 with-formtext'
    //   } else {
    //     return 'mx-0'
    //   }
    // } else {
    if (error) {
      return 'has-error';
    } else {
      return '';
    }
    // }
  };

  renderThemedSelector = () => {
    const { selected, timezones, error } = this.props;
    // if (theme === 4) {
    //   return <Col xs='8' sm='9'>
    //     <Select
    //       className='Select--sm'
    //       id="profile_timezone"
    //       name="profile_timezone"
    //       clearable={false}
    //       value={selected}
    //       placeholder={<FormattedMessage id="main.select" defaultMessage="Select..." />}
    //       onChange={this.handleChange}
    //       options={timezones.map(zone => ({
    //         value: zone.name,
    //         label: zone.name + ' (' + zone.value + ')',
    //       }))}
    //     />
    //     {error && <small className="form-text">{error}</small>}
    //   </Col>
    // } else {
    return (
      <>
        <Select
          id="profile_timezone"
          name="profile_timezone"
          clearable={false}
          value={selected}
          placeholder={<FormattedMessage id="main.select" defaultMessage="Select..." />}
          onChange={this.handleChange}
          options={timezones.map((zone) => ({
            value: zone.name,
            label: zone.name + ' (' + zone.value + ')',
          }))}
        />
        {error && <small className="form-text">{error}</small>}
      </>
    );
    // }
  };

  render() {
    return (
      <FormGroup className={cn("form-group-upper-label", this.getClassNames())}>
        <Label htmlFor="profile_timezone">
          <FormattedMessage id="profile.timezone" defaultMessage="Time Zone" />
        </Label>

        {this.renderThemedSelector()}
      </FormGroup>
    );
  }
}

export default TimezoneSelector;
